export default __webpack_public_path__ + "images/7982a4a547c6d500c2afbba89cdbff34-Barlow-Medium.woff";